import * as actionType from '../actionTypes';

const initialState = {
    smsEmailLogs:[],
    smsEmaildata: []
}
const smsEmailReducer = (state = initialState, action) => {
    // debugger;
    switch (action.type) {
        case actionType.SMS_EMAIL_LOGS:
            return {
                ...state,
                smsEmaildata: action.smsEmaildata,
                smsEmailLogs:action.smsEmaildata.logs
            };
        default:
            return state
    }
}
export default smsEmailReducer;
